import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "../../lib/content";

export const Ribbon = () => (
  <section data-testid="ribbon" className="bg-secondary py-8 md:py-10 overflow-hidden">
    <Marquee speed={38} gradient={false} autoFill>
      {MARQUEE_WORDS.map((w, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display italic font-light text-secondary-foreground text-4xl md:text-6xl px-10 md:px-16">
            {w}
          </span>
          <span className="text-primary text-2xl md:text-4xl">✦</span>
        </div>
      ))}
    </Marquee>
  </section>
);
